<div class="toolbar-horizontal" style="width: 100%">
    <span title="Line Numbers"><input type="checkbox" [(ngModel)]="lineNos"><i class="far fa-list-ol"></i></span>
    <span title="Word Wrap"><input type="checkbox" [(ngModel)]="wordWrap"><i class="far fa-arrow-u-turn-down-left"></i></span>
    <span title="Dark Mode"><input type="checkbox" [(ngModel)]="darkMode"><i class="far fa-moon-star"></i></span>
    <span title="Minimap"><input type="checkbox" [(ngModel)]="minimap"><i class="far fa-align-right"></i></span>
    <span style="flex: 1">&nbsp;</span>
    <fluent-button appearance="stealth" (click)="onCopy()" title="Copy to Clipboard"><i class="far fa-paste"></i></fluent-button>
</div>
<iframe #editor src="/monaco/monaco-iframe.html">

</iframe>
